import type { Instrument } from '@thinkalpha/common/schemas/instruments.js';

export type UpdateOrderBlotterAccountAction = {
    type: 'updateOrderBlotterAccount';
    tabId: string;
    accountIds: string[] | null;
};
export const updateOrderBlotterAccount = (
    tabId: string,
    accountIds: string[] | null,
): UpdateOrderBlotterAccountAction => ({
    tabId,
    accountIds,
    type: 'updateOrderBlotterAccount',
});

export type UpdateOrderBlotterInstrumentAction = {
    type: 'updateOrderBlotterInstrument' | 'linkingUpdateOrderBlotterInstrument';
    tabId: string;
    instrument: Instrument;
};
export const updateOrderBlotterInstrument = (
    tabId: string,
    instrument: Instrument,
    isLinking = false,
): UpdateOrderBlotterInstrumentAction => ({
    tabId,
    instrument,
    type: isLinking ? 'linkingUpdateOrderBlotterInstrument' : 'updateOrderBlotterInstrument',
});

export type UserDoubleClickedOrderFromBlotterAction = {
    type: 'userDoubleClickedOrderFromBlotter';
    tabId: string;
    symbol?: string;
    accountId?: string;
};
export const userDoubleClickedOrderFromBlotter = (
    tabId: string,
    symbol?: string,
    accountId?: string,
): UserDoubleClickedOrderFromBlotterAction => ({
    tabId,
    symbol,
    accountId,
    type: 'userDoubleClickedOrderFromBlotter',
});

export type OrderBlotterActions =
    | UpdateOrderBlotterAccountAction
    | UpdateOrderBlotterInstrumentAction
    | UserDoubleClickedOrderFromBlotterAction;
